import React from 'react';

const ProjectsHeader = () => {
    return (
        <div className="resume-header">
            <h1 className="ms-5 align-middle p-5">My Projects</h1>
        </div>
    );
};

export default ProjectsHeader;